"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSolubility = void 0;
const extractExperimentalData_1 = require("./extractExperimentalData");
/**
 * Returns the solubility of a compound
 * @param data Data of a compound data request to the PubChem API
 * @returns ExperimentalData
 */
function getSolubility(data) {
    const solubility = (0, extractExperimentalData_1.extractExperimentalData)(data, 'Solubility');
    return solubility;
}
exports.getSolubility = getSolubility;
//# sourceMappingURL=getSolubility.js.map